const Dashboard = () => {
  return <div></div>;
};

export default Dashboard;
